/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Périmètre d'un valideur du tunnel.
 * @export
 * @interface SetTunnelValideurCourtiersCommand
 */
export interface SetTunnelValideurCourtiersCommand {
    /**
     * Courtiers auxquels le valideur est restreint ; vide = tous les courtiers habilités.
     * @type {Array<string>}
     * @memberof SetTunnelValideurCourtiersCommand
     */
    courtierIds: Array<string>;
}

/**
 * Check if a given object implements the SetTunnelValideurCourtiersCommand interface.
 */
export function instanceOfSetTunnelValideurCourtiersCommand(value: object): value is SetTunnelValideurCourtiersCommand {
    if (!('courtierIds' in value) || value['courtierIds'] === undefined) return false;
    return true;
}

export function SetTunnelValideurCourtiersCommandFromJSON(json: any): SetTunnelValideurCourtiersCommand {
    return SetTunnelValideurCourtiersCommandFromJSONTyped(json, false);
}

export function SetTunnelValideurCourtiersCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetTunnelValideurCourtiersCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'courtierIds': json['courtierIds'],
    };
}

export function SetTunnelValideurCourtiersCommandToJSON(json: any): SetTunnelValideurCourtiersCommand {
    return SetTunnelValideurCourtiersCommandToJSONTyped(json, false);
}

export function SetTunnelValideurCourtiersCommandToJSONTyped(value?: SetTunnelValideurCourtiersCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courtierIds': value['courtierIds'],
    };
}

